import gql from "graphql-tag";

const GET_QUIZ_RESULTS_BY_SUBMISSION_ID = gql`
    query getQuizResultsBySubmissionId (
        $submissionId: String!
    ) {
        getQuizResultsBySubmissionId (
            getQuizResultsBySubmissionInput: {
                submissionId: $submissionId
            }
        ) {
            id
            poolId
            quizId
            questionResults {
                question {
                    id
                    orderNumber
                    question
                    answers {
                        id
                        orderNumber
                        isCorrect
                        answer
                    }
                }
                userAnswer {
                    id
                    questionId
                    points
                    isCorrect
                    isLastQuestion
                    nextQuestion {
                        id
                        orderNumber
                        question
                        answers {
                            id
                            orderNumber
                            isCorrect
                            answer
                        }
                    }
                    quizTracker {
                        id
                        pool_id
                        quiz_id
                        user_id
                        start_time
                        end_time
                        createdAt
                        updatedAt
                        isSuccessful
                        score
                        last_answered_question_id
                    }
                }
            }
        }
    }
`

export default GET_QUIZ_RESULTS_BY_SUBMISSION_ID;